import { render, staticRenderFns } from "./AgacPage.vue?vue&type=template&id=606097da&scoped=true&"
import script from "./AgacPage.vue?vue&type=script&lang=js&"
export * from "./AgacPage.vue?vue&type=script&lang=js&"
import style0 from "./AgacPage.vue?vue&type=style&index=0&id=606097da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606097da",
  null
  
)

export default component.exports